//images Web Dev
//clearcert
import clearcert1 from "../assets/images/clearcert-1.png";
import clearcert2 from "../assets/images/clearcert-2.png";

//shubhraranjan
import shubhraranjan1 from "../assets/images/shaubhra-ranjan-1.png";
import shubhraranjan2 from "../assets/images/shaubhra-ranjan-2.png";

//sahyog Homecare
import sahyog1 from "../assets/images/Sahyog-1.png";
import sahyog2 from "../assets/images/Sahyog-2.png";

// Hollyminds
import hollyminds1 from "../assets/images/hollymind-1.png";
import hollyminds2 from "../assets/images/hollymind-2.png";

//trisha properties
import trisha1 from "../assets/images/trisha-1.png";
import trisha2 from "../assets/images/trisha-2.png";

//Shubhra Ranjan Current Affairs
import shubhramcq1 from "../assets/images/mcq-1.png";
import shubhramcq2 from "../assets/images/mcq-2.png";

//AcquireSign
import aqur1 from "../assets/images/aqur-1.png";
import aqur2 from "../assets/images/aqur-2.png";

//File.Digital
import filedigital1 from "../assets/images/filedigital-1.png";
import filedigital2 from "../assets/images/filedigital-2.png";

//zodev
import zodev1 from "../assets/images/zodev-1.png";
import zodev2 from "../assets/images/zodev-2.png";

//myuk
import myuk1 from "../assets/images/myuk-1.png";
import myuk2 from "../assets/images/myuk-2.png";

//dattamandir
import dattamandir1 from "../assets/images/dattmandir-1.png";
import dattamandir2 from "../assets/images/dattmandir-2.png";

//Yobykes Dealer Management System
import yobykes1 from "../assets/images/yobyke-1.png";
import yobykes2 from "../assets/images/yobyke-2.png";

//de asra
import deaasra1 from "../assets/images/deaasra-1.png";
import deaasra2 from "../assets/images/deaasra-2.png";

// images App Dev

//shubhra android
import shubhraandroid1 from "../assets/images/shubhraandroid-1.png";
import shubhraandroid2 from "../assets/images/shubhraandroid-2.png";

//shubhra ios
import shubhraIOS1 from "../assets/images/shubhraIOS-1.png";
import shubhraIOS2 from "../assets/images/shubhraIOS-2.png";

//shubhra tablet
import shubhratablet1 from "../assets/images/shubhratablet-1.png";
import shubhratablet2 from "../assets/images/shubhratablet-2.png";
import shubhratablet3 from "../assets/images/shubhratablet-3.png";

//Du
//shubhra ios
import du1 from "../assets/images/du-1.png";
import du2 from "../assets/images/du-2.png";

const PortfolioDataWeb = [
  {
    id: 1,
    title: "Shubhra Ranjan",
    images: [shubhraranjan1, shubhraranjan2],
    technologies: [
      "React JS",
      "Node JS",
      "MySQL (AWS RDS)",
      "Gitlab (Project Repository)",
      "Ubuntu 20.0.4 (AWS EC2 Instances for website and Node JS API deployment)",
    ],
    liveLinks: [
      { name: "Shubhraranjan Website", url: "https://shubhraranjan.com" },
      {
        name: "Shubhraranjan Admin",
        url: "http://admin.shubhraranjan.com/admin",
      },
      {
        name: "Shubhraranjan Staff",
        url: "http://staff.shubhraranjan.com/staff",
      },
      {
        name: "Shubhraranjan Affiliates",
        url: "https://affiliates.shubhraviraj.in/Affiliates/login",
      },
    ],
    description:
      "Shubhra Ranjan IAS Study is India’s well-known institute to prepare for Civil Services Examinations in India. Shubhra Ranjan is a renowned educator specializing in Civil Services Examination (CSE) preparation in India. Her website, shubhraranjan.com, offers a range of courses and resources tailored for aspirants aiming to excel in the CSE. This application has different portals like public website, student portal, website administrator portal, Affiliates Portal, Evaluation portal etc. I have developed and managed these portals. I am responsible for new development and change requests implementation. Shubhra Ranjan public website is developed using React JS and Backend API is developed using Node JS (express). MySQL is the database",
  },
  {
    id: 2,
    title: "ClearCert",
    images: [clearcert1, clearcert2],
    technologies: [
      "ASP.Net MVC 5.0",
      "MSSQL (AWS RDS)",
      "GitHub (Project Repository)",
      "Windows Server 2019 (AWS EC2 Instances for website)",
    ],
    liveLinks: [
      { name: "Clearcert Client", url: "https://client.clearcert.com/client" },
      {
        name: "Clearcert Administrator",
        url: "https://administrator.clearcert.com/administrator",
      },
      {
        name: "Clearcert Certification",
        url: "https://certification.clearcert.com/",
      },
      { name: "Clearcert iqd", url: "https://iqd.clearcert.com/" },
      { name: "Clearcert Annuity", url: "https://annuity.clearcert.com/" },
      { name: "Clearcert Flood", url: "https://flood.clearcert.com/" },
    ],
    description:
      "ClearCert is a company that specializes in providing compliance and certification solutions for insurance and financial services professionals. Key features1. Continuing Education (CE) Compliance Management:2. Annuity Suitability Training Verification:3. Long-Term Care (LTC) Partnership Training Certification:4. Anti-Money Laundering (AML) Training Compliance:5. Product-Specific Training (PST) Management:I am responsible for client portal, administrator portal and different certification web services. I have integrated AWS S3, PayFlow PayPal as payment gateway. This application is build using ASP.Net MVC 5.0. I have developed certification reminder windows service and email marketing email service and integrated MailChimp as email platform",
    keyFeatures: [
      " Continuing Education (CE) Compliance Management:",
      "Annuity Suitability Training Verification:",
      " Long-Term Care (LTC) Partnership Training Certification:",
      "  Anti-Money Laundering (AML) Training Compliance:",
      " Product-Specific Training (PST) Management:",
    ],
  },

  {
    id: 3,
    title: "Sahyog Homecare",
    images: [sahyog1, sahyog2],
    technologies: [
      "React JS ",
      "Node JS ",
      "GitHub (Project Repository)",
      "MSSQL (AWS RDS)",
      "Tailwind CSS",
    ],
    liveLinks: [
      { name: "Website", url: "https://sahayoghomecare.com/" },
      { name: "Admin Panel ", url: "https://admin.sahayoghomecare.com/" },
    ],
    description:
      "Sahyog Homecare & Health Services is a healthcare-focused website developed to provide reliable, compassionate, and accessible homecare and medical support services. The website was designed with a patient-centric approach, emphasizing clarity, trust, and ease of navigation to help users quickly understand available healthcare services. It presents detailed information about home nursing, elderly care, medical assistance, and health support solutions in a structured and user-friendly manner.The platform features a clean, responsive design optimized for all devices, ensuring a smooth browsing experience for patients and caregivers alike. Clear service sections, intuitive layouts, and strong call-to-actions make it easy for users to inquire about services or get in touch with healthcare professionals. Built with performance, accessibility, and SEO best practices, the Sahyog Homecare website strengthens the organization’s digital presence while reflecting its commitment to quality care and dependable health services.Secure financial analytics dashboard focused on data visualization and compliance reporting.",
  },
  {
    id: 4,
    title: "Trisha Properties",
    images: [trisha1, trisha2],
    technologies: [
      "React JS ",
      "Node JS ",
      "GitHub (Project Repository)",
      "MSSQL (AWS RDS)",
      "Tailwind CSS",
    ],
    liveLinks: [
      { name: "Website", url: "https://trishaproperties.com/" },
      { name: "Admin Panel", url: "https://admin.trishaproperties.com/" },
    ],
    description:
      "Trisha Properties is a real estate platform designed to showcase and sell residential and commercial properties with clarity, trust, and ease of use. The website was developed to provide potential buyers with a seamless property-browsing experience while highlighting key property details, locations, and offerings in a clean and organized manner. The design focuses on simplicity and usability, ensuring that users can easily explore listings, view property information, and connect with the sales team without friction.The website features a modern, responsive layout optimized for all devices, allowing users to browse properties comfortably on desktop, tablet, or mobile. Strategic content placement, clear call-to-actions, and visually appealing property sections help guide users through the buying journey, from discovery to inquiry. Built with performance and SEO best practices in mind, the Trisha Properties website strengthens the brand’s online presence and serves as an effective digital tool for generating leads and promoting real estate offerings.",
  },
  {
    id: 5,
    title: "Holly Minds",
    images: [hollyminds1, hollyminds2],
    technologies: [
      "React JS ",
      "Node JS ",
      "GitHub (Project Repository)",
      "MSSQL (AWS RDS)",
      "Tailwind CSS",
    ],
    liveLinks: [
      { name: "Website", url: "https://hollyminds.com" },
      { name: "Admin Panel", url: "https://admin.hollyminds.com" },
    ],
    description:
      "Hollyminds is a creative branding and design company focused on building strong, meaningful brand identities for modern businesses. The website was designed and developed to reflect the company’s creative vision, professionalism, and design expertise. The primary goal of the project was to create a visually compelling digital presence that clearly communicates Hollyminds’ branding services while showcasing their creative work in an engaging and impactful way.The website emphasizes a brand-centric design approach, combining modern UI/UX principles with strategic content placement to enhance storytelling and user engagement. It features a clean layout, bold visuals, and smooth interactions that align with the creative nature of the brand. Fully responsive and performance-optimized, the website ensures a seamless experience across all devices while maintaining fast load times and SEO-friendly architecture.Overall, the Hollyminds website serves as a strong digital identity for the brand—positioning the company as a creative partner that delivers thoughtful, innovative, and visually driven branding solutions.",
    keyFeatures: [
      "Strategic brand-centric website design",
      "High-impact visual storytelling through UI/UX",
      "Responsive and pixel-perfect layouts",
      "Creative portfolio showcase with smooth interactions",
      "Performance-optimized and SEO-ready architecture",
    ],
  },

  {
    id: 6,
    title: "Shubhra Ranjan Current Affairs",
    images: [shubhramcq1, shubhramcq2],
    technologies: [
      "Angular JS ",
      "ASP.Net Web API",
      "MSSQL 2019",
      "Gitlab (Project Repository)",
      "Windows Server 2019 (AWS EC2 Instances for website)",
    ],
    liveLinks: [
      { name: "Website", url: "https://currentaffairs.shubhraranjan.com" },
      {
        name: "Admin Panel",
        url: "http://currentaffairsadmin.shubhraranjan.com/#/auth/login",
      },
    ],
    description:
      " The website Shubh Bharat Times provides curated current affairs updates relevant for Civil Services Examination preparation. It includes daily news analysis, editorial insights, government policies, and international affairs, helping aspirants stay informed. This application is developed using Angular JS and API is developed using ASP.Net Web API.Website content is managed using Admin portal.",
  },
  {
    id: 7,
    title: "AcquireSign",
    images: [aqur1, aqur2],
    technologies: ["ASP.NetC#", "MVC", "MSSQL2014", "jQuery"],
    liveLinks: [{ name: "Website Link", url: "https://www.acquiresign.com/" }],
    description:
      "AcquireSign is the future of electronic signing and digital approval.Forward-thinking, future-proof, and secure, AcquireSign takes electronic signing one step further with advanced verification and security.Users can send and sign contracts digitally. Here, we have integrated PayPal Pro and Barclays Payment Gateway with card tokenization.Users can create and edit contracts online and send them in PDF format.",
  },
  {
    id: 8,
    title: "File.Digital",
    images: [filedigital1, filedigital2],
    technologies: ["ASP.NetMVCC#", "MSSQL2014"],
    liveLinks: [{ name: "Website Link", url: "https://file.digital/" }],
    description:
      "File.Digital is a service that gives you the power to store files in the cloud and share them securely. Our software will help you and your staff to create and collaborate, safe in the knowledge that your documents are protected by powerful encryption.With new data regulation protections set to come into force in the UK and the EU, our service is an easy way to achieve peace of mind.",
  },
  {
    id: 9,
    title: "ZoDevDesign",
    images: [zodev1, zodev2],
    technologies: ["PHP", "MySQL", "jQuery"],
    liveLinks: [{ name: "Website Link", url: "https://zodevdesign.com/" }],
    description:
      "ZoDevDesign is a digital visualization company that specializes in 3D architectural renderings, architectural illustrations, and animations.They produce high-quality architectural renderings, 3D illustrations, and animations for commercial and residential architectural projects.ZoDevDesign has many expert designers who develop quality designs at an affordable price solution.",
  },
  {
    id: 10,
    title: "Datta Mandir",
    images: [dattamandir1, dattamandir2],
    technologies: [
      "React JS",
      "Node JS",
      "MySQL (AWS RDS)",
      "Gitlab (Project Repository)",
      "Ubuntu 20.0.4 (AWS EC2 Instances for website and Node JS API deployment)",
    ],
    liveLinks: [
      { name: "Website", url: "https://dattamandir.com" },
      { name: "Admin Panel", url: "http://admin.dattamandir.com" },
    ],
    keyFeatures: [
      "Devotional Content: Access sacred scriptures, bhajans, and religious teachings.",
      "Event Updates: Stay informed about upcoming temple events, festivals, and rituals.",
      "Secure Access: Privileged access ensures a dedicated experience for authorized users.",
      " Interactive Features: Users can submit prayer requests, book pujas, and contribute donations.",
      "Responsive Design: Optimized for smooth performance across all devices.",
    ],
    description:
      "DattaMandir – A Privileged Devotional Site DattaMandir is a React-based privileged website designed to provide devotees with a seamless and enriching spiritual experience. This platform offers a secure and user-friendly interface, allowing users to explore religious content, participate in virtual prayers, and stay updated with temple events.",
  },
  {
    id: 11,
    title: "MyUKpost",
    images: [myuk1, myuk2],
    technologies: ["ASP.NetC#", "MVC", "MSSQL2014", "jQuery"],
    liveLinks: [
      { name: "Website", url: "https://www.myukpost.com" },
      {
        name: "Personal-mail-forwarding",
        url: "https://www.myukpost.com/personal-mail-forwarding",
      },
    ],
    description:
      "myUKpost offers a safe, reliable and effective Mail Forwarding/Scanning address and delivery service to individual customers and businesses from anywhere in the world. We give you a real UK postal address, based in Manchester or London fixed for life.myUKpost is the leading UK based mail address service provider catering to the mail forwarding requirements of individual customers, businesses and expatriates from around the world all needing a UK address. We are 100% legal, real and fully compliant and we follow the Money Laundering Rules and Regulations.So you have peace of mind and security with us. All monies received are processed via Paypal, Barclaycard, Mastercard & Visa which also adds to extra client protection. None of our sent mail is held on any server connected to myUKpost, again giving you extra security & protection. All clients & users must provide us with ID and proof of residence or reasonable equivalent.Whoever you choose to provide your mail services; please ensure they have all these legally required licences.",
  },
  {
    id: 12,
    title: "Yobykes Dealer Management System",
    images: [yobykes1, yobykes2],
    technologies: [
      "React JS",
      "Node JS",
      "MySQL (AWS RDS)",
      "Gitlab (Project Repository)",
      "Ubuntu 20.0.4 (AWS EC2 Instances for website and Node JS API deployment)",
    ],
    liveLinks: [
      { name: "Website", url: "https://dms.yobykes.com/" },
      { name: "Dealer", url: "http://dms.yobykes.com/dealer" },
    ],
    keyFeatures: [
      "Area wise distributor and dealer management",
      "Bykes inventory management at company level and dealer level",
      "Distributor/Dealer bykes order processing and dispatch",
      "Spare parts inventory management",
      " Distributor/Dealer spare parts order management",
      "Order Management",
      "Dispatch & Logistics Management",
      "Marketing Scheme Management",
      "Sales Management",
      "Item replacement Management",
      "Reports",
    ],
    description:
      "YoBykes is a pioneering brand in the electric vehicle (EV) industry in India, focusing on the development and manufacturing of electric two-wheelers. We have developed dealer management system for Yobykes.",
  },
  {
    id: 13,
    title: "DesAsra",
    images: [deaasra1, deaasra2],
    technologies: [
      "React JS",
      "Python Django",
      "MySQL (AWS RDS)",
      "Gitlab (Project Repository)",
      "Ubuntu 20.0.4 (AWS EC2 Instances for website and Python Django API deployment)",
    ],
    liveLinks: [{ name: "Admin ", url: "https://webadmin.deasra.in/login" }],
    description:
      "deAsra Foundation is a non-profit organization dedicated to empowering entrepreneurs and small businesses in India by providing comprehensive support services.I have developed administrator portal for this application using React JS and Python Django. I have developed different python APIs and integrated those in React JS application. I have integrated InstaMojo as payment gateway, Zoho books as invoice management system and business WhatsApp API (Sobot) integration. When customer request for any service from website or facilitator can request service on behalf of customer using administrator portal. We are responsible for service request, auto assignment of facilitator to service, service partner assignment, payment request and invoice generation and other service stages till service delivery.",
  },
];

//  MOBILE SPECIFIC DATA

const PortfolioDataMobile = [
  {
    id: 21,
    title: "Shubhra Ranjan Android",
    images: [shubhraandroid1, shubhraandroid2],
    technologies: ["Android Studio (Java + Kotlin)"],
    liveLinks: [
      {
        name: "App Preview",
        url: "https://play.google.com/store/apps/details?id=com.shubhraranjanmobile",
      },
    ],
    description:
      "Shubhra Ranjan Android is a comprehensive learning platform designed for aspirants preparing for competitive exams like UPSC, State PSCs, and other government job exams. Our app provides high-quality study materials, live and recorded lectures, test series, and personalized guidance to help students achieve their goals.Shubhra Ranjan Android Mobile application is developed for subscribed students for UPSC courses. Students can view recorded as well as live lectures on mobile using this application. In this application we have integrated VdoCipher SDK for live lecture and recorded lecture streaming. AWS live streaming is also an option for live lectures. We have developed Prelims Tests and Mains Tests module where student can attempt Prelims Test and Main Tests. There are different options for students to view recorded lectures such as Lecture By Notes, Lecture By Subject etc. We have developed on demand course module for students where students can watch the course lectures during course period as per their convenience and at a time student can unlock three lectures to view.We have implemented socket programming to log student lecture view time. We have developed this application in native Android Kotlin",
  },
  {
    id: 22,
    title: "Shubhra Ranjan IOS",
    images: [shubhraIOS1, shubhraIOS2],
    technologies: ["XCode (Swift)"],
    liveLinks: [
      {
        name: "App Preview",
        url: "https://apps.apple.com/us/app/shubhra-ranjan/id6474115818",
      },
    ],
    description:
      "Shubhra Ranjan iOS is a comprehensive learning platform designed for aspirants preparing for competitive exams like UPSC, State PSCs, and other government job exams. Our app provides high-quality study materials, live and recorded lectures, test series, and personalized guidance to help students achieve their goals. Prepare smartly and stay ahead in your competitive exam journey with Shubhra Ranjan iOS! Shubhra Ranjan iOS Mobile application is developed for subscribed students for UPSC courses. Students can view recorded as well as live lectures on mobile using this application. In this application we have integrated VdoCipher SDK for live lecture and recorded lecture streaming. AWS live streaming is also an option for live lectures. We have developed Prelims Tests and Mains Tests module where student can attempt Prelims Test and Main Tests. There are different options for students to view recorded lectures such as Lecture By Notes, Lecture By Subject etc. We have developed on demand course module for students where students can watch the course lectures during course period as per their convenience and at a time student can unlock three lectures to view.We have implemented socket programming to log student lecture view time. We have developed this application in native iOS swift",
  },
  {
    id: 23,
    title: "Shubhra Ranjan Tablet",
    images: [shubhratablet1, shubhratablet2, shubhratablet3],
    technologies: ["Android Studio (Java + Kotlin)"],
    liveLinks: [
      {
        name: "App Preview (Tablet)",
        url: "https://play.google.com/store/apps/details?id=com.shubhraranjanmobile",
      },
      {
        name: "App Preview (iPad)",
        url: "https://apps.apple.com/us/app/shubhra-ranjan/id6474115818",
      },
    ],
    description:
      "Shubhra Ranjan Tablet is a powerful learning platform optimized for tablet users, providing a seamless experience for competitive exam preparation. Designed for UPSC, State PSCs, and other government job aspirants, the app offers high-quality study materials, interactive video lectures, and structured test series. With a larger screen and enhanced readability, tablet users can enjoy an immersive learning experience like never before.Shubhra Ranjan Tablet Android Mobile application is developed for subscribed students for UPSC courses. Students can view recorded as well as live lectures on mobile using this application. This application is for tablet course subscribed students and this tablet is controlled using Samsung KnoxIn this application we have integrated VdoCipher SDK for live lecture and recorded lecture streaming. AWS live streaming is also an option for live lectures. We have developed Prelims Tests and Mains Tests module where student can attempt Prelims Test and Main Tests. There are different options for students to view recorded lectures such as Lecture By Notes, Lecture By Subject etc. We have developed on demand course module for students where students can watch the course lectures during course period as per their convenience and at a time student can unlock three lectures to view.We have implemented socket programming to log student lecture view time. We have developed this application in native Android Kotlin",
  },
  {
    id: 24,
    title: "Du",
    images: [du1,du2],
    technologies: ["Swift", "REST Web API", "C#", "Java"],
    keyFeatures: [
      "Digital document filing and sharing system",
      "Replaces e-statements, emails, and portals for better document management",
      "Secure online document storage and sharing",
      "Android and iOS application for seamless access",
      "Mobile services developed using REST Web API",
      "Hosted on AWS Cloud for scalability and security",
      "Intelligent and automated document organization",
      "User-friendly interface for easy document retrieval",
      "Enhanced data privacy and security features.",
    ],
    //  liveLinks: [{ name: "App Preview (Tablet)", url: "https://play.google.com/store/apps/details?id=com.shubhraranjanmobile" }  ,{ name: "App Preview (iPad)", url: "https://apps.apple.com/us/app/shubhra-ranjan/id6474115818" },],
    description:
      "Du is a truly digital solution and intelligent personal document filing and sharing system, replacinge-statements, emails, portals and manymore!! Here we have developed document management and online sharing system. We have developed Android and iOS application. Developed mobiles ervices using Rest Web API and hostedon AWS Cloud",
  },
];

export { PortfolioDataWeb, PortfolioDataMobile };
export default PortfolioDataWeb;
